import axios from "../api";
/**
 * Adds one card to the user's club by hand — web's `addPlayerToClub`, same
 * endpoint. Returns the new card's EA item id.
 */
export const addPlayerToClub = async (player) => {
    const res = await axios.post("/user-players", {
        resourceId: player.resourceId,
        rating: player.rating,
        untradeable: player.untradeable,
        activeSquad: player.activeSquad,
        transferList: player.transferList,
        manuallyAdded: true,
        preferredPosition: player.preferredPosition,
    });
    return res.data;
};
//# sourceMappingURL=addPlayerToClub.js.map